/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Password_InvalidInputs */

const en_error_password_invalid = /** @type {(inputs: Error_Password_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This password can't be used.`)
};

/**
* | output |
* | --- |
* | "This password can't be used." |
*
* @param {Error_Password_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_password_invalid = /** @type {((inputs?: Error_Password_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Password_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_password_invalid(inputs)
});